import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Chip,
  Collapse,
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useState, useEffect, useCallback } from "react";
import { get, post } from "../../../utils/api";
import BulkUploadAdd from "./BulkUploadAdd";
import BulkFileUpload from "../../Scope1/FugitiveEmmissions/BulkFileUpload";

const isOtherVendorName = (value) =>
  String(value || "")
    .trim()
    .toLowerCase() === "other";

const OTHER_VENDOR_ERROR =
  "Please select another name. 'Other' is not allowed.";

const BulkUpload = ({
  matchData,
  setMatchData,
  onClose,
  onConfirm,
  bulkUploadTable,
  bulkuploadInputData,
  url,
  title1,
  title2,
  title3,
  keyValue1,
  keyValue2,
  keyValue3,
  options1,
  options2,
  options3,
  matched1,
  matched2,
  matched3,
  setFormDataBulkUpload,
  formDataBulkUpload,
  bulkUploadUrl,
  setsnackOpen,
}) => {
  const [expandedRows, setExpandedRows] = useState({});
  const [disabled, setDisabled] = useState(false);

  const [formData, setFormData] = useState([]);
  const [errors, setErrors] = useState({});

  // Document upload state management
  const [finalJson, setFinalJson] = useState(formDataBulkUpload);
  const [uploadValidationErrors, setUploadValidationErrors] = useState([]);
  const [hasValidationBeenAttempted, setHasValidationBeenAttempted] =
    useState(false);

  // Document upload confirmation state
  const [documentUploadConfirmed, setDocumentUploadConfirmed] = useState(false);
  // Document upload type state
  const [documentUploadType, setDocumentUploadType] = useState("none"); // "none", "individual", "same"
  const [commonDocument, setCommonDocument] = useState(null);
  const [individualDocuments, setIndividualDocuments] = useState({});
  // State to show confirmation dialog for proceeding without documents
  const [showNoDocumentDialog, setShowNoDocumentDialog] = useState(false);

  const inputData = [
    {
      fieldName: "vendorLegalName",
      title: "Vendor Legal Name",
      placeholder: "Enter Name",
      type: "text",
    },
    // {
    //   fieldName: "facility",
    //   title: "Facility",
    //   placeholder: "Select type",
    //   type: "select",
    //   url: `${api}/master/getAllFacility`,
    //   field: "facilityName",
    // },
    {
      fieldName: "wasteManagementType",
      title: "Type of Waste Management",
      // type: "select",
      type: "text",
      // options: ["Recycling", "Landfilling", "Incineration", "Composting"],
      placeholder: "Select type",
    },
    {
      fieldName: "govtVendorRegistrationNumber",
      title: "Govt. Vendor Registration Number",
      placeholder: "Enter Registration Number",
      type: "number",
    },
  ];

  const [data, setData] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);

  const getEnteredVendorName = (item, index) =>
    item?.[keyValue1] ||
    item?.[title1] ||
    formDataBulkUpload?.[index]?.[title1] ||
    finalJson?.[index]?.[title1] ||
    "";

  const getUploadedVendorName = (index) => {
    const row = formDataBulkUpload?.[index];
    const item = matchData?.[index];

    const pick = (...values) => {
      for (const value of values) {
        if (value && value !== "add_new") {
          return value;
        }
      }
      return "";
    };

    return pick(
      row?.[keyValue1],
      row?.vendor,
      item?.[keyValue1],
      item?.vendor,
      row?.[title1],
      item?.[title1]
    );
  };

  const getMatchedVendorLegalName = (item, index) => {
    if (item?.vendorData?.vendorLegalName) {
      return item.vendorData.vendorLegalName;
    }

    const selected =
      formDataBulkUpload?.[index]?.[title1] || finalJson?.[index]?.[title1];
    if (selected && selected !== "add_new") {
      return selected;
    }

    const fromItem = item?.[keyValue1] || item?.vendor;
    if (fromItem && fromItem !== "add_new") {
      return fromItem;
    }

    return "";
  };

  const getWasteManagementMethod = (item, index) =>
    item?.wasteManagementMethod ||
    item?.["Waste Management Method"] ||
    formDataBulkUpload?.[index]?.["Waste Management Method"] ||
    finalJson?.[index]?.["Waste Management Method"] ||
    "";

  const isVendorMatched = useCallback(
    (item) =>
      Boolean(item?.[matched1] || item?.vendorMatched || item?.vendorData),
    [matched1],
  );

  useEffect(() => {
    if (!matchData?.length) return;

    matchData.forEach((item, index) => {
      const vendorName = getEnteredVendorName(item, index);
      if (
        isVendorMatched(item) ||
        String(vendorName).trim().toLowerCase() !== "other"
      ) {
        return;
      }

      setExpandedRows((prev) =>
        prev[index] ? prev : { ...prev, [index]: true },
      );
      setFormData((prev) =>
        prev[index]?.vendorLegalName
          ? prev
          : {
              ...prev,
              [index]: {
                ...prev[index],
                vendorLegalName: vendorName,
                wasteManagementType: getWasteManagementMethod(item, index),
              },
            },
      );
    });
  }, [matchData, title1, isVendorMatched]);

  const fetchData = async () => {
    try {
      const response = await get(`/master/wasteManagement`);

      setData(response.data.data); // Now setData contains only the names
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    const isMatched = matchData.every((item, index) => {
      const isMatched = isVendorMatched(item);
      const selectedVendor = finalJson[index]?.[title1];
      const isSelected =
        selectedVendor &&
        selectedVendor !== "" &&
        selectedVendor !== "add_new" &&
        !isOtherVendorName(selectedVendor);
      return isMatched || isSelected;
    });

    // const disable = Object.values(finalJson)?.some(item =>
    //   (title2 && !options2?.includes(item?.[title2])) ||
    //   (title1 && !options1?.includes(item?.[title1]))
    // );
    setDisabled(!isMatched);
  }, [finalJson, matchData, matched1, title1, isVendorMatched]);

  if (!matchData || matchData.length === 0) {
    return null;
  }

  // const handleFormChange = (index, field, value) => {
  //   setFormDataBulkUpload((prev) => ({
  //     ...prev,
  //     [index]: {
  //       ...prev[index],
  //       [field]: value,
  //     },
  //   }));
  //   console.log(formDataBulkUpload, "formDataBulkUpload");
  // };
  const handleFormChange = (index, field, value) => {
    if (field === title1 && value === "add_new") {
      setExpandedRows((prev) => ({
        ...prev,
        [index]: true,
      }));
      setMatchData((prev) =>
        prev.map((item, i) =>
          i === index ? { ...item, [matched1]: false } : item
        )
      );
      setFormData((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          vendorLegalName: "",
          wasteManagementType: getWasteManagementMethod(matchData?.[index], index),
        },
      }));
      setFormDataBulkUpload((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [field]: value,
        },
      }));
      setFinalJson((prev) => {
        const newArray = [...prev];
        newArray[index] = {
          ...newArray[index],
          [field]: value,
        };
        return newArray;
      });
      setErrors((prev) => ({
        ...prev,
        [index]: {},
      }));
      return;
    }

    if (field === title1 && value !== "") {
      setExpandedRows((prev) => ({
        ...prev,
        [index]: false,
      }));

      // Clear form fields but keep the selectedEquipment value
      setFormDataBulkUpload((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [field]: value,
        },
      }));
      setFinalJson((prev) => {
        const newArray = [...prev];
        newArray[index] = {
          ...newArray[index],
          [field]: value,
        };
        return newArray;
      });
      setErrors((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [field]: "",
        },
      }));
      setMatchData((prev) =>
        prev.map((item, i) =>
          i === index ? { ...item, [matched1]: true } : item,
        ),
      );
    } else if (field !== title1) {
      setFormDataBulkUpload((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [field]: value,
        },
      }));
      setFinalJson((prev) => {
        const newArray = [...prev];
        newArray[index] = {
          ...newArray[index],
          [field]: value,
        };
        return newArray;
      });
    }
  };

  const handleVendorAdded = (itemData, index) => {
    const vendorName = itemData?.vendorLegalName || "";
    if (!vendorName) return;

    setFormDataBulkUpload((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [title1]: vendorName,
      },
    }));

    setFinalJson((prev) => {
      const next = [...prev];
      next[index] = {
        ...next[index],
        [title1]: vendorName,
      };
      return next;
    });

    fetchData();
  };

  // Document upload handler functions
  const handleDocumentUploadConfirmation = (confirmed) => {
    setDocumentUploadConfirmed(confirmed);

    if (!confirmed) {
      // Reset document upload type to "none" if user chooses not to upload
      setDocumentUploadType("none");
    }

    // Clear validation errors when document upload confirmation changes
    setUploadValidationErrors([]);
    setHasValidationBeenAttempted(false);
  };

  const handleDocumentUploadTypeChange = (event) => {
    setDocumentUploadType(event.target.value);

    setCommonDocument(null);
    setIndividualDocuments({});

    // Clear validation errors when document upload type is selected
    setUploadValidationErrors([]);
    setHasValidationBeenAttempted(false);
  };

  const handleCommonDocumentChange = (files) => {
    setCommonDocument(files);

    // Update finalJson with common document for all entries
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry) => ({
        ...entry,
        "Document (optional)": files,
      }));
      setFinalJson(updated);
    }

    // Clear validation errors when documents are uploaded
    if (files && files.length > 0) {
      setUploadValidationErrors([]);
      setHasValidationBeenAttempted(false);
    }
  };

  const handleIndividualDocumentChange = (index, files) => {
    setIndividualDocuments((prev) => ({
      ...prev,
      [index]: files,
    }));

    // Update finalJson with individual document for specific entry
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": files,
          };
        }
        return entry;
      });
      setFinalJson(updated);
    }

    // Clear validation errors when documents are uploaded
    if (files && files.length > 0) {
      setUploadValidationErrors([]);
      setHasValidationBeenAttempted(false);
    }
  };

  const handleClearCommonDocument = () => {
    setCommonDocument(null);

    // Update finalJson to clear common document for all entries
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry) => ({
        ...entry,
        "Document (optional)": null,
      }));
      setFinalJson(updated);
    }
  };

  const handleClearIndividualDocument = (index) => {
    setIndividualDocuments((prev) => {
      const newDocs = { ...prev };
      delete newDocs[index];
      return newDocs;
    });

    // Update finalJson to clear individual document for specific entry
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": null,
          };
        }
        return entry;
      });
      setFinalJson(updated);
    }
  };

  const handleProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
    performUpload();
  };

  const handleCancelProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
  };

  const validateUploadData = () => {
    const validationErrors = [];

    // Check if user wants to upload documents but hasn't uploaded any
    if (documentUploadConfirmed && documentUploadType === "none") {
      validationErrors.push(
        "Please select a document upload type when document upload is confirmed.",
      );
    }

    // Validate document upload requirements
    if (documentUploadConfirmed && documentUploadType !== "none") {
      const hasCommonDoc =
        documentUploadType === "same" &&
        commonDocument &&
        commonDocument.length > 0;
      const hasIndividualDocs =
        documentUploadType === "individual" &&
        Object.keys(individualDocuments).length > 0 &&
        Object.values(individualDocuments).some(
          (docs) => docs && docs.length > 0,
        );
      if (!hasCommonDoc && !hasIndividualDocs) {
        setShowNoDocumentDialog(true);
      }
    }
    return validationErrors;
  };

  const performUpload = async () => {
    // Use jsonBulkUpload as fallback if finalJson is empty
    const dataToUse =
      finalJson && finalJson.length > 0 ? finalJson : formDataBulkUpload;

    // Prepare data structure for upload
    const uploadData = {
      excelData: dataToUse,
      documentUploadType: documentUploadType,
      commonDocument: commonDocument,
      individualDocuments: individualDocuments,
    };

    console.log("Final upload data structure:", uploadData);

    if (bulkUploadUrl) {
      await post(bulkUploadUrl, uploadData)
        .then((res) => {
          const responseData = res?.data || {};
          const inserted = Number(responseData?.inserted ?? 0);
          const skipped = Number(responseData?.skipped ?? 0);
          // Clear validation errors and reset validation attempted flag on successful upload
          setUploadValidationErrors([]);
          setHasValidationBeenAttempted(false);
          setsnackOpen({
            open: true,
            message:
              responseData.message ||
              (skipped > 0
                ? `${inserted} entr${inserted === 1 ? "y" : "ies"} inserted. ${skipped} row${skipped === 1 ? "" : "s"} skipped.`
                : "Uploaded successfully"),
            severity: skipped > 0 ? "warning" : "success",
          });
          onConfirm(responseData);
          onClose();
        })
        .catch((err) => {
          const errMessage = err.response?.data?.details
            ?.map((el) => el?.error)
            ?.join(",");
          if (err?.response?.status === 422) {
          }
          setsnackOpen({
            open: true,
            message:
              errMessage ?? err.response?.data?.message ?? "Network Error",
            severity: "error",
          });
        });
    } else {
      // Fallback to original onConfirm if no bulkUploadUrl provided
      onConfirm();
    }
  };

  const handleSubmit = async () => {
    // Mark that validation has been attempted
    setHasValidationBeenAttempted(true);

    const validationErrors = validateUploadData();
    console.log(validationErrors, "validationErrors");

    if (validationErrors.length > 0) {
      setUploadValidationErrors(validationErrors);
      return;
    }

    // Check if user wants to upload documents but hasn't uploaded any
    const needsDocs = documentUploadConfirmed && documentUploadType !== "none";

    if (needsDocs) {
      const hasCommonDoc =
        documentUploadType === "same" &&
        commonDocument &&
        commonDocument.length > 0;
      const hasIndividualDocs =
        documentUploadType === "individual" &&
        Object.keys(individualDocuments).length > 0 &&
        Object.values(individualDocuments).some(
          (docs) => docs && docs.length > 0,
        );

      if (!hasCommonDoc && !hasIndividualDocs) {
        setShowNoDocumentDialog(true);
        return;
      }
    }

    // If no dialog is needed, proceed with upload
    await performUpload();
  };

  console.log("onConfirm prop:", onConfirm);

  return (
    <>
      <Dialog
        open={bulkUploadTable}
        onClose={onClose}
        maxWidth="lg"
        sx={{
          "& .MuiDialog-paper": {
            width: "85%",
            margin: "16px",
            maxHeight: "calc(100% - 32px)",
            zIndex: 1000,
          },
        }}
      >
        <DialogTitle>Review Bulk Upload Data</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Review the matched and unmatched equipment data. Add unmatched items
            individually.
          </Typography>

          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", width: "35%" }}>
                    Data Entered
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", width: "35%" }}>
                    Master Data
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                    Action
                  </TableCell>
                  {documentUploadConfirmed &&
                    documentUploadType === "individual" && (
                      <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                        Document
                      </TableCell>
                    )}
                </TableRow>
              </TableHead>
              <TableHead>
                <TableRow sx={{ overflowX: "hidden" }}>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    {title1 || "Vendor Name"}
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    {title1 || "Vendor Name"}
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
                  {documentUploadConfirmed &&
                    documentUploadType === "individual" && (
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Document
                      </TableCell>
                    )}
                </TableRow>
              </TableHead>
              <TableBody>
                {matchData.map((item, index) => {
                  const uploadedName = getUploadedVendorName(index);
                  const isAddNewSelected =
                    formDataBulkUpload[index]?.[title1] === "add_new";
                  const matchedVendorLegalName = getMatchedVendorLegalName(
                    item,
                    index
                  );
                  const displayName =
                    isAddNewSelected && isOtherVendorName(uploadedName)
                      ? ""
                      : isVendorMatched(item) &&
                          isOtherVendorName(uploadedName) &&
                          matchedVendorLegalName
                        ? matchedVendorLegalName
                        : uploadedName || "-";
                  const showOtherError =
                    isOtherVendorName(uploadedName) &&
                    !isVendorMatched(item) &&
                    !isAddNewSelected;

                  return (
                  <>
                    <TableRow key={index} sx={{ overflowX: "hidden" }}>
                      <TableCell>
                        <Box>
                          <Typography component="span">
                            {displayName}
                          </Typography>
                          {showOtherError && (
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#D34040",
                                mt: 0.5,
                                fontSize: "12px",
                                wordBreak: "break-word",
                              }}
                            >
                              {OTHER_VENDOR_ERROR}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {isVendorMatched(item) ? (
                          <Chip label="Matched" color="success" size="small" />
                        ) : (
                          <FormControl
                            size="small"
                            sx={{ minWidth: "12rem", maxWidth: "16rem" }}
                          >
                            <Select
                              value={
                                formDataBulkUpload[index]?.[title1] ===
                                  "Other" ||
                                formDataBulkUpload[index]?.[title1] ===
                                  "add_new"
                                  ? ""
                                  : formDataBulkUpload[index]?.[title1] || ""
                              }
                              onChange={(e) =>
                                handleFormChange(index, title1, e.target.value)
                              }
                              fullWidth
                              displayEmpty
                              MenuProps={{
                                PaperProps: {
                                  sx: { maxHeight: 240 },
                                },
                              }}
                              renderValue={(selected) => {
                                if (!selected || selected === "Other") {
                                  return "Tap to Select";
                                }
                                if (selected === "add_new") {
                                  return "Add New Vendor +";
                                }
                                return selected;
                              }}
                            >
                              <MenuItem value="" disabled>
                                Tap to Select
                              </MenuItem>
                              <MenuItem value="add_new">Add New Vendor +</MenuItem>
                              {data?.map((vendor) => (
                                <MenuItem
                                  key={vendor?._id || vendor?.vendorLegalName}
                                  value={vendor?.vendorLegalName}
                                >
                                  {vendor?.vendorLegalName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </TableCell>
                      <TableCell>
                        {!isVendorMatched(item) && isAddNewSelected ? (
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => {
                              setExpandedRows((prev) => ({
                                ...prev,
                                [index]: false,
                              }));
                              setFormDataBulkUpload((prev) => ({
                                ...prev,
                                [index]: {
                                  ...prev[index],
                                  [title1]: "",
                                },
                              }));
                              setFinalJson((prev) => {
                                const newArray = [...prev];
                                newArray[index] = {
                                  ...newArray[index],
                                  [title1]: "",
                                };
                                return newArray;
                              });
                            }}
                            sx={{ minWidth: "60px" }}
                          >
                            Close
                          </Button>
                        ) : null}
                      </TableCell>
                      {documentUploadConfirmed &&
                        documentUploadType === "individual" && (
                          <TableCell>
                            <BulkFileUpload
                              filesList={individualDocuments[index] || []}
                              handleChange={handleIndividualDocumentChange}
                              handleClear={handleClearIndividualDocument}
                              index={index}
                            />
                          </TableCell>
                        )}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                        colSpan={
                          documentUploadConfirmed &&
                          documentUploadType === "individual"
                            ? 4
                            : 3
                        }
                      >
                        <Collapse
                          in={isAddNewSelected}
                          timeout="auto"
                          unmountOnExit
                        >
                          <BulkUploadAdd
                            index={index}
                            inputData={inputData}
                            formData={formData}
                            errors={errors[index]}
                            setErrors={setErrors}
                            setFormData={setFormData}
                            setExpandedRows={setExpandedRows}
                            equipment={item.equipment}
                            url={url}
                            value={item?.[keyValue1]}
                            matchData={matchData}
                            setMatchData={setMatchData}
                            bulkuploadInputData={inputData}
                            data={data}
                            submitUrl={`/master/wasteManagement`}
                            setsnackOpen={setsnackOpen}
                            matched={matched1}
                            onAddItem={handleVendorAdded}
                          />
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Document Upload Section */}
          <Box
            sx={{ mt: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}
          >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
              Document Upload
            </Typography>
            <Box>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  Do you want to upload document?
                </FormLabel>
                <RadioGroup
                  value={documentUploadConfirmed ? "yes" : "no"}
                  onChange={(e) =>
                    handleDocumentUploadConfirmation(e.target.value === "yes")
                  }
                  row
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
            {documentUploadConfirmed && (
              <FormControl component="fieldset" sx={{ mb: 2, mt: 2 }}>
                <FormLabel component="legend">Document Upload Type</FormLabel>
                <RadioGroup
                  value={documentUploadType}
                  onChange={handleDocumentUploadTypeChange}
                  row
                >
                  <FormControlLabel
                    value="same"
                    control={<Radio />}
                    label="Same File for All Records"
                  />
                  <FormControlLabel
                    value="individual"
                    control={<Radio />}
                    label="Individual File for Each Record"
                  />
                </RadioGroup>
              </FormControl>
            )}

            {documentUploadConfirmed && documentUploadType === "same" && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Upload a single document that will be associated with all
                  records:
                </Typography>
                <BulkFileUpload
                  filesList={commonDocument}
                  handleChange={handleCommonDocumentChange}
                  handleClear={handleClearCommonDocument}
                />
              </Box>
            )}

            {documentUploadConfirmed && documentUploadType === "individual" && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Upload individual documents for each record. Documents will be
                  added as a new column in the table above.
                </Typography>
              </Box>
            )}
          </Box>

          {/* Validation Error Display - Only show after validation has been attempted */}
          {hasValidationBeenAttempted && uploadValidationErrors.length > 0 && (
            <Box
              sx={{
                mt: 2,
                p: 2,
                backgroundColor: "#ffebee",
                borderRadius: 1,
                border: "1px solid #f44336",
              }}
            >
              <Typography
                variant="h6"
                color="error"
                sx={{ mb: 1, fontWeight: "bold" }}
              >
                Error:
              </Typography>
              {uploadValidationErrors.map((error, index) => (
                <Typography
                  key={index}
                  variant="body2"
                  color="error"
                  sx={{ mb: 0.5 }}
                >
                  • {error}
                </Typography>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "1rem" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            sx={{ marginRight: "1rem" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={disabled}
          >
            Confirm Upload
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog for Proceeding Without Documents */}
      <Dialog
        open={showNoDocumentDialog}
        onClose={handleCancelProceedWithoutDocuments}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6">No Documents Uploaded</Typography>
            <IconButton
              onClick={handleCancelProceedWithoutDocuments}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            You have selected to upload documents but haven't uploaded any
            files.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Do you want to proceed without uploading documents?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You can still upload documents later if needed.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: "1rem" }}>
          <Button
            onClick={handleCancelProceedWithoutDocuments}
            variant="outlined"
            color="primary"
            sx={{ marginRight: "1rem" }}
          >
            Upload Documents
          </Button>
          <Button
            onClick={handleProceedWithoutDocuments}
            variant="contained"
            color="primary"
          >
            Proceed Without Documents
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BulkUpload;
